
export const queryLoaded = (query: any): boolean => {
    const queryLength = Object.keys(query).length;
    const q = new URLSearchParams(window.location.search);
    const keys = [...q.keys()].filter((v, i, a) => a.indexOf(v) === i);
    return keys.length === queryLength;
};